import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { InformativeMessage } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface InformativeMessagesParams extends DefaultHttpHeaders {
  applicationName?: ApplicationNameInformativeMessagesParamsEnum;
}

export type ApplicationNameInformativeMessagesParamsEnum = 'mktg';

@Injectable()
export class InformativeMessagesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining informative messages
   * Service for obtaining informative messages
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Application%20Utilities/getMarketingMessages
   */
  informativeMessages(params: InformativeMessagesParams): Observable<InformativeMessage[]> {
    const pathParams = {
      applicationName: params.applicationName ?? 'mktg',
    };
    return this.get<InformativeMessage[]>({
      suffix: `/comeround/applicationUtilities/informativeMessages/${pathParams.applicationName}`,
    });
  }
}
